import { useState, useEffect } from "react";

export const useTapCounter = () => {
  const getRandomCount = () => Math.floor(Math.random() * (1000 - 100 + 1)) + 100;
  
  const [count, setCount] = useState(() => {
    const savedCount = localStorage.getItem('tapCounter');
    return savedCount ? parseInt(savedCount, 10) : getRandomCount();
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prevCount => prevCount + 1);
    }, 1000); 

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    localStorage.setItem('tapCounter', count.toString());
  }, [count]);

  const increment = () => {
    setCount(prevCount => prevCount + 1);
  };

  const reset = () => {
    const newCount = getRandomCount();
    setCount(newCount);
  };

  return { count, increment, reset };
};